import { Link } from "react-router-dom";
import { AGENTS } from "../data";
import { Label, Panel, PanelHeader, Reveal, StatusDot } from "../components/primitives";
import { DataStatus } from "../components/DataStatus";

export default function Leaderboard() {
  return (
    <main className="pt-16" data-testid="leaderboard-page">
      <div className="grid-bg border-b border-white/[0.06]">
        <div className="mx-auto flex max-w-[1440px] flex-wrap items-end justify-between gap-6 px-5 py-16 md:px-8 md:py-20">
          <Reveal>
            <div className="flex items-center gap-3"><StatusDot tone="muted" /><Label>Ranked agent performance — real events only</Label></div>
            <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-fog-100 sm:text-5xl">AGENT LEADERBOARD</h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-fog-400 sm:text-base">
              Agent rankings activate when deployed agents produce real, verifiable events. No simulated
              performance figures are displayed.
            </p>
          </Reveal>
          <DataStatus status="NOT DEPLOYED" label="Agent Services" pulse={false} />
        </div>
      </div>

      <div className="mx-auto max-w-[1440px] px-5 py-10 md:px-8">
        <Panel>
          <PanelHeader right={<DataStatus status="NOT DEPLOYED" pulse={false} />}>Performance Ranking</PanelHeader>
          <div className="overflow-x-auto" data-testid="leaderboard-table">
            <table className="w-full min-w-[720px] font-mono text-xs">
              <thead>
                <tr className="border-b border-white/[0.08] text-left text-[9px] uppercase tracking-[0.2em] text-fog-600">
                  <th className="px-4 py-3">Agent</th>
                  <th className="px-4 py-3">Role</th>
                  <th className="px-4 py-3">Risk</th>
                  <th className="px-4 py-3 text-right">Signals</th>
                  <th className="px-4 py-3 text-right">Accuracy</th>
                  <th className="px-4 py-3 text-right">Guardian OK</th>
                  <th className="px-4 py-3 text-right">Streak</th>
                  <th className="px-4 py-3 text-right">Status</th>
                </tr>
              </thead>
              <tbody>
                {AGENTS.map((a) => (
                  <tr key={a.id} className="border-b border-white/[0.04] transition-colors hover:bg-white/[0.03]" data-testid={`leaderboard-row-${a.id.toLowerCase()}`}>
                    <td className="px-4 py-3">
                      <Link to="/agents" className="font-bold text-fog-100 hover:text-pulse-soft">{a.id}</Link>
                    </td>
                    <td className="px-4 py-3 text-fog-400">{a.role}</td>
                    <td className="px-4 py-3 text-fog-400">{a.risk}</td>
                    <td className="px-4 py-3 text-right text-fog-600">N/A</td>
                    <td className="px-4 py-3 text-right text-fog-600">N/A</td>
                    <td className="px-4 py-3 text-right text-fog-600">N/A</td>
                    <td className="px-4 py-3 text-right text-fog-600">N/A</td>
                    <td className="px-4 py-3 text-right">
                      <span className="inline-flex items-center gap-1.5 text-fog-600">
                        <StatusDot tone="muted" /> NOT DEPLOYED
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Panel>

        <p className="mt-6 max-w-2xl font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-fog-600">
          An agent is only labeled ACTIVE when a backend service is running, receiving real data and producing
          real events. Until then, all performance metrics remain N/A.
        </p>
      </div>
    </main>
  );
}
